import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {config_general_template} from "../components/templates/config_general_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;


export class config_general extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected configGeneral: config_general_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    public fillPage() {
        this.getGeneralConfigData()
    }

    buildContent(): Array<Element> {
        this.configGeneral = new config_general_template("config_general", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("General");

        return [this.configGeneral.build()];
    }

    protected getModuleName(): string {
        return "config_general";
    }

    private getGeneralConfigData() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/generalconfig/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetGeneralConfigDataReturn;
        this.XHRHdl.execute();
    }

    private onGetGeneralConfigDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                // let related_brands_data = responseParsed.datas.related_brands;
                let siteSettings = responseParsed.datas.general_site_settings;
                let pencilBanner = responseParsed.datas.pencil_banner;

                if(pencilBanner){
                    obj.configGeneral.setPencilBanner(pencilBanner);
                }

                //set login system email templates

                if (siteSettings != null) {
                    obj.configGeneral.setSiteName(siteSettings.siteName);
                    obj.configGeneral.setAlternateSiteName(siteSettings.alternateSiteName);
                    obj.configGeneral.setTitle(siteSettings.title);
                    obj.configGeneral.setDescription(siteSettings.description);
                    obj.configGeneral.setRssChannelDescription(siteSettings.rssChannelDescription);
                    obj.configGeneral.setRssAdContent(siteSettings.rssAdContent);
                    obj.configGeneral.setFoundingDate(siteSettings.foundingDate);
                    obj.configGeneral.setGtmAccount(siteSettings.gtmAccount);
                    obj.configGeneral.setFbAppAccount(siteSettings.fbappAccount);
                    obj.configGeneral.setSiteGa4MeasurementId(siteSettings.sitega4MeasurementId);
                    obj.configGeneral.setSentinelMeasurementID(siteSettings.sentinelMeasurementID);
                    obj.configGeneral.setCampaignerAccountId(siteSettings.campaignerAccountId);
                    obj.configGeneral.setDisqusCommentCountOnBrowseClip(siteSettings.disqusCommentCountOnBrowseClip);
                    obj.configGeneral.setDisqusForumShortname(siteSettings.disqusForumShortname);
                    obj.configGeneral.setOpenWebSpotId(siteSettings.openwebSpotId);
                    obj.configGeneral.setEchoboxEnable(siteSettings.echoboxEnable);
                    obj.configGeneral.setSovrnId(siteSettings.sovrnId);
                    obj.configGeneral.setSkimlinksId(siteSettings.skimlinksId);
                    obj.configGeneral.setHowlId(siteSettings.howlId);
                    obj.configGeneral.setContactAddress(siteSettings.contactAddress);
                    obj.configGeneral.setExternalLinkWhitelist(siteSettings.externalLinkWhitelist);
                }
                //let currencyOption = obj.

                // related_brands_data.sort(function (item1, item2) {
                //     return (item1.order > item2.order) ? 1 : -1;
                // });
                //
                // //All properties of parsed json data are observables now
                // let mapped_related_brands_data = ko.utils.arrayMap(related_brands_data, function (item) {
                //     return new RelatedBrands(item.idBrand, item.brandName, item.brandShortName ,item.brandIcon,
                //         item.text, item.enabled, item.dateCreated, item.dateUpdated)
                // });
                //
                // obj.configGeneral.setRelatedBrandLinks(mapped_related_brands_data);

                let follow_links_data = responseParsed.datas.follow_links;

                if(follow_links_data){

                    for (let fld of follow_links_data){
                        if(fld.type === "facebook"){
                            obj.configGeneral.setFacebookDataOnForm(fld);
                        }

                        if(fld.type === "instagram"){
                            obj.configGeneral.setInstagramDataOnForm(fld);
                        }

                        if(fld.type === "twitter"){
                            obj.configGeneral.setTwitterDataOnForm(fld);
                        }

                        if(fld.type === "tiktok"){
                            obj.configGeneral.setTiktokDataOnForm(fld);
                        }

                        if(fld.type === "linkedin"){
                            obj.configGeneral.setLinkedInDataOnForm(fld);
                        }

                        if(fld.type === "bluesky"){
                            obj.configGeneral.setBlueSkyDataOnForm(fld);
                        }

                        if(fld.type === "twitch"){
                            obj.configGeneral.setTwitchDataOnForm(fld);
                        }

                        if(fld.type === "pinterest"){
                            obj.configGeneral.setPinterestDataOnForm(fld);
                        }

                        if(fld.type === "spotify"){
                            obj.configGeneral.setSpotifyDataOnForm(fld);
                        }

                        if(fld.type === "anchor"){
                            obj.configGeneral.setAnchorDataOnForm(fld);
                        }

                        if(fld.type === "megaphone"){
                            obj.configGeneral.setMegaphoneDataOnForm(fld);
                        }

                        if(fld.type === "discord"){
                            obj.configGeneral.setDiscordDataOnForm(fld);
                        }

                        if(fld.type === "telegram"){
                            obj.configGeneral.setTelegramDataOnForm(fld);
                        }

                        if(fld.type === "snapchat"){
                            obj.configGeneral.setSnapchatDataOnForm(fld);
                        }

                        if(fld.type === "youtube"){
                            obj.configGeneral.setYoutubeDataOnForm(fld);
                        }

                        if(fld.type === "feed"){
                            obj.configGeneral.setRssFeedDataOnForm(fld);
                        }

                        if(fld.type === "newspaper"){
                            obj.configGeneral.setNewsletterDataOnForm(fld);
                        }

                        if(fld.type === "feedly"){
                            obj.configGeneral.setFeedlyDataOnForm(fld);
                        }

                        if(fld.type === "pushbullet"){
                            obj.configGeneral.setPushbulletDataOnForm(fld);
                        }

                        if(fld.type === "google-news"){
                            obj.configGeneral.setGoogleNewsDataOnForm(fld);
                        }

                        if(fld.type === "reddit"){
                            obj.configGeneral.setRedditDataOnForm(fld);
                        }

                        if(fld.type === "flipboard"){
                            obj.configGeneral.setFlipboardDataOnForm(fld);
                        }

                        if(fld.type === "amazon"){
                            obj.configGeneral.setAmazonDataOnForm(fld);
                        }

                        if(fld.type === "acast"){
                            obj.configGeneral.setAcastDataOnForm(fld);
                        }
                    }
                }
            })
        }
    }

    protected saveData(param, data) {
        this.loadingIn(this.configGeneral.builtTemplate)
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/generalconfig/save/";
        let formReq_params: Array<Array<string>> = [];

        // let relatedBrandLinks_viewModel = ko.toJS(this.viewModel.config_general.relatedBrandLinks)
        //
        // //We keep on enabled == true to save
        // relatedBrandLinks_viewModel = relatedBrandLinks_viewModel.filter(function (vm) {
        //     return vm.enabled === true
        // })
        //
        // if(relatedBrandLinks_viewModel){
        //
        //     //Delete useless props and update the date
        //     relatedBrandLinks_viewModel.forEach(function (vm) {
        //         delete vm.brandIcon
        //         delete vm.order
        //         //delete vm.brandName
        //         vm.dateUpdated = (new Date().toISOString()).substring(0,10)
        //     })
        //
        // }

        // let followUsLinks_viewModel = this.buildFollowLinksViewModel()
        let followUsLinks_viewModel = ko.toJS(this.configGeneral.buildFollowLinksViewModel())

        if(followUsLinks_viewModel){
            followUsLinks_viewModel = followUsLinks_viewModel.filter(function (vm) {
                return vm.enabled === true
            })
        }

        //Which form will send the request

        // if(param === "related_brands"){
        //     formReq_params.push(["data", ko.toJSON(relatedBrandLinks_viewModel)]);
        //     formReq_params.push(["param", param]);
        // }

        if(param === "follow_links"){
            formReq_params.push(["data", ko.toJSON(followUsLinks_viewModel)]);
            formReq_params.push(["param", param]);
        }

        if(!this.configGeneral.isPencilBannerEnabled()){
            this.configGeneral.clearPencilBanner();
        }

        let pencilBanner_viewModel = ko.toJS(this.configGeneral.getPencilBanner())

        if(param === "pencil_banner"){
            formReq_params.push(["data", ko.toJSON(pencilBanner_viewModel)]);
            formReq_params.push(["param", param]);
        }


        let handler: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        handler.mode = XMLHttpRequestHandler_requestType.POST;

        handler.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                    page.redirect("/brand/"+idBrand+"/config/general/");

                });


                obj.loadingOut(obj.configGeneral.builtTemplate);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "SAVED!");
            }
        });
        handler.execute();
    }

    protected saveSiteSettings(param, data) {
        this.loadingIn(this.configGeneral.builtTemplate);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/generalconfig/site-settings/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.configGeneral.getSiteSettings()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                    page.redirect("/brand/"+idBrand+"/config/general/");

                });
                obj.loadingOut(obj.configGeneral.builtTemplate);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "SAVED!");
                // obj.getVnAppZone().showNotificationToModule();

            }
        });
        XHRHdl.execute();
    }

    public cancelForm() {
        this.cancelFollowUsLinks();
        this.cancelRelatedBrandLinks();
        page.redirect(this.getVnAppZone().app.getLastRoute());
    }

    protected cancelFollowUsLinks() {
        this.backAction()
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "FOLLOW US LINKS changes cancelled!");
    }

    protected cancelRelatedBrandLinks() {
        this.backAction()
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "RELATED BRANDS LINKS changes cancelled!");
    }

    protected cancelSiteSettings() {
        this.backAction()
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "SITE SETTINGS changes cancelled!");
    }

    protected cancelPencilBanner(){
        this.backAction()
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Pencil Banner changes cancelled!");
    }

    protected backAction(){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect("/brand/"+idBrand+"/config/general/");

    }

}


class RelatedBrands {

    idBrand: any
    brandName: any
    brandShortName: any
    brandIcon: any
    text: any
    enabled: any
    dateCreated: any
    dateUpdated: any


    constructor(idBrand: any, brandName: any, brandShortName: any ,brandIcon: any, text: any, enabled: any, dateCreated: any, dateUpdated: any) {
        this.idBrand = ko.observable(idBrand);
        this.brandName = ko.observable(brandName);
        this.brandShortName = ko.observable(brandShortName);
        this.brandIcon = ko.observable(brandIcon);
        this.text = ko.observable(text);
        this.enabled = ko.observable(enabled);
        this.dateCreated = ko.observable(dateCreated);
        this.dateUpdated = ko.observable(dateUpdated);
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_general.ts